import { createAction, props } from '@ngrx/store';
import { Update } from '@ngrx/entity';

import { DrupalData } from './drupal-data.model';
import { JsonApiQuery } from '../json-api.query';
import { Tree } from '@nx-icilalune/drupal-types';

export const setState = createAction(
  '[DrupalData/API] set State',
  props<{ newState: any }>()
);

export const sendRequest = createAction(
  '[DrupalData/API] Send Request',
  props<{ request: JsonApiQuery; contextId?: string }>()
);

export const sendRequestSuccess = createAction(
  '[DrupalData/API] Send Request Success',
  props<{
    request: JsonApiQuery;
    ids?: string[];
    contextId?: string;
    canNext: boolean;
  }>()
);

export const sendRequestError = createAction(
  '[DrupalData/API] Send Request Error',
  props<{
    request: JsonApiQuery;
    contextId?: string;
    error: Error;
  }>()
);

export const loadDrupalDatas = createAction(
  '[DrupalData/API] Load DrupalDatas',
  props<{ drupalDatas: DrupalData[] }>()
);

export const addDrupalData = createAction(
  '[DrupalData/API] Add DrupalData',
  props<{ drupalData: DrupalData }>()
);

export const upsertDrupalData = createAction(
  '[DrupalData/API] Upsert DrupalData',
  props<{ drupalData: DrupalData }>()
);

export const addDrupalDatas = createAction(
  '[DrupalData/API] Add DrupalDatas',
  props<{ drupalDatas: DrupalData[] }>()
);

export const upsertDrupalDatas = createAction(
  '[DrupalData/API] Upsert DrupalDatas',
  props<{ drupalDatas: DrupalData[] }>()
);

export const updateDrupalData = createAction(
  '[DrupalData/API] Update DrupalData',
  props<{ drupalData: Update<DrupalData> }>()
);

export const updateDrupalDatas = createAction(
  '[DrupalData/API] Update DrupalDatas',
  props<{ drupalDatas: Update<DrupalData>[] }>()
);

export const deleteDrupalData = createAction(
  '[DrupalData/API] Delete DrupalData',
  props<{ id: string }>()
);

export const deleteDrupalDatas = createAction(
  '[DrupalData/API] Delete DrupalDatas',
  props<{ ids: string[] }>()
);

export const clearDrupalDatas = createAction(
  '[DrupalData/API] Clear DrupalDatas'
);

export const setMainMenu = createAction(
  '[DrupalData/API] Set Main Menu',
  props<{ menu: Tree<any> }>()
);

export const setMenu = createAction(
  '[DrupalData/API] Set Menu',
  props<{ menu: Tree<any>; key: string }>()
);

export const setTypologiesMenu = createAction(
  '[DrupalData/API] Set Typologies Menu',
  props<{ menu: Tree<any> }>()
);

export const setLanguage = createAction(
  '[DrupalData/API] Set Language',
  props<{ lang: string }>()
);
